<template>
  <div class="vuestic-data-table table-responsive">
    <div class="sticky">
      <div class="d-flex flex-md-row flex-column align-items-center" :class="controlsAlignmentClass">
        <filter-bar
          @filter="onFilterSet"
          :label="filterInputLabel"
          v-show="filterInputShown"
        />
        <div class="form-group with-icon-left">
          <div class="input-group">
            <vuestic-date-picker
              id="date-picker-basic"
              v-model="dueDate"
              :config="dateConfig"
            />
            <i class="fa fa-calendar icon-left input-icon"></i>
            <label class="control-label" for="date-picker-basic">
              Due Date
            </label>
            <i class="bar"></i>
          </div>
        </div>
        <div class="datatable-controls d-flex flex-row">
          <div class="form-group">
            <slot name="additionalTableControl"></slot>
          </div>
          <items-per-page :options="itemsPerPage"
                          :label="itemsPerPageLabel"
                          :defaultPerPage="defaultPerPageComputed"
                          @items-per-page="onItemsPerPage"
                          v-show="perPageSelectorShown"></items-per-page>
        </div>
      </div>
      <div class="d-flex flex-md-row flex-column align-items-center justify-content-center mt-2 mb-2">
        <div class="btn-group sale-btn" role="group" aria-label="First group">
          <button
            type="button"
            class="btn btn-primary btn-micro"
            @click="onChangeSaleType(0)"
            :class="{focus: saleType == 0}">
            <i class="fa fa-pencil-square-o"></i>
            <span class="dkt-sign">Delivery Instore</span>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-micro"
            @click="onChangeSaleType(1)"
            :class="{focus: saleType == 1}">
            <i class="fa fa-road"></i>
            <span class="dkt-sign">En Route</span>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-micro"
            @click="onChangeSaleType(2)"
            :class="{focus: saleType == 2}">
            <i class="fa fa-motorcycle"></i>
            <span class="dkt-sign">Delivered</span>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-micro"
            @click="onChangeSaleType(3)"
            :class="{focus: saleType == 3}">
            <i class="fa fa-home"></i>
            <span class="dkt-sign">TA Instore</span>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-micro"
            @click="onChangeSaleType(4)"
            :class="{focus: saleType == 4}">
            <i class="fa fa-truck"></i>
            <span class="dkt-sign">TA Collected</span>
          </button>
        </div>
      </div>
    </div>
    <div class="table-holder">
      <vuetable
        ref="vuetable"
        :apiUrl="apiUrl"
        :apiMode="apiMode"
        :httpFetch="httpFetch"
        :httpOptions="httpOptions"
        :fields="tableFields"
        :dataManager="dataManager"
        :css="css.table"
        dataPath="data"
        :paginationPath="paginationPathComputed"
        :appendParams="moreParams"
        :row-class="onRowClass"
        :perPage="perPage"
        :queryParams="queryParams"
        @vuetable:pagination-data="onPaginationData"
      />
    </div>
    <div class="d-flex justify-content-center mb-4">
      <vuetable-pagination ref="pagination"
                           :css="css.pagination"
                           :onEachSide="onEachSide"
                           @vuetable-pagination:change-page="onChangePage">

      </vuetable-pagination>
    </div>
  </div>
</template>

<script>
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
  import FilterBar from './datatable-components/FilterBar.vue'
  import ItemsPerPage from './datatable-components/ItemsPerPage.vue'
  import DefaultPerPageDefinition from './data/items-per-page-definition'
  import Vue from 'vue'
  import DataTableStyles from '../vuestic-datatable/data/data-table-styles'

  export default {
    name: 'vuestic-data-table',
    components: {
      FilterBar,
      Vuetable,
      VuetablePagination,
      ItemsPerPage
    },
    props: {
      apiUrl: {
        type: String
      },
      httpFetch: {
        type: Function,
        default: null
      },
      httpOptions: {
        type: Object,
        default: () => {}
      },
      filterQuery: {
        type: String,
        default: 'filter'
      },
      tableFields: {
        type: Array,
        required: true
      },
      itemsPerPage: {
        type: Array,
        default: () => DefaultPerPageDefinition.itemsPerPage
      },
      perPageSelectorShown: {
        type: Boolean,
        default: true
      },
      filterInputShown: {
        type: Boolean,
        default: true
      },
      filterInputLabel: {
        type: String,
        default: 'Search'
      },
      itemsPerPageLabel: {
        type: String,
        default: 'per page'
      },
      defaultPerPage: {
        type: Number,
        default: DefaultPerPageDefinition.itemsPerPage[0].value
      },
      onEachSide: {
        type: Number,
        default: 2
      },
      apiMode: {
        type: Boolean,
        default: true
      },
      tableData: {
        type: Object,
        default () {
          return {
            data: []
          }
        }
      },
      dataModeFilterableFields: {
        type: Array,
        default: () => []
      },
      sortFunctions: {
        type: Object
      },
      paginationPath: {
        type: String,
        default: ''
      },
      queryParams: {
        type: Object
      },
      setSaleType: {
        type: Function
      },
      setDueDate: {
        type: Function
      },
      saleType: {
        type: Number
      },
      currentDueDate: {
        type: String
      }
    },
    data () {
      return {
        perPage: 0,
        colorClasses: {},
        filterText: '',
        dataCount: 0,
        css: DataTableStyles,
        dateConfig: {
          wrap: true,
          static: true
        },
      }
    },
    computed: {
      controlsAlignmentClass () {
        return {
          'justify-content-md-between': this.filterInputShown,
          'justify-content-md-end': !this.filterInputShown
        }
      },
      dueDate: {
        get () {
          return this.currentDueDate
        },
        set (value) {
          this.setDueDate(value)
        },
      },
      moreParams () {
        return {
          [this.filterQuery]: this.filterText
        }
      },
      dataModeFilterableFieldsComputed () {
        const dataItem = this.tableData.data[0] || {}
        const filterableFields = this.dataModeFilterableFields

        if (!filterableFields.length) {
          const itemFields = Object.keys(dataItem)
          itemFields.forEach(field => {
            if (typeof dataItem[field] !== 'object') {
              filterableFields.push(field)
            }
          })
        }

        return filterableFields
      },
      filteredTableData () {
        const txt = new RegExp(this.filterText, 'i')

        let filteredData = this.tableData.data.slice()

        filteredData = this.tableData.data.filter((item) => {
          return this.dataModeFilterableFieldsComputed.some(field => {
            const val = item[field] + ''
            return val.search(txt) >= 0
          })
        })

        return {
          data: filteredData
        }
      },
      defaultPerPageComputed () {
        let defaultPerPage = DefaultPerPageDefinition.itemsPerPage[0].value

        if (this.$options.propsData.defaultPerPage) {
          defaultPerPage = this.$options.propsData.defaultPerPage
        } else if (this.$options.propsData.itemsPerPage) {
          defaultPerPage = this.$options.propsData.itemsPerPage[0].value
        }

        return defaultPerPage
      },
      paginationPathComputed () {
        return this.apiMode ? this.paginationPath : 'pagination'
      }
    },

    created () {
      this.perPage = this.defaultPerPageComputed
    },

    mounted () {
      this.$emit('initialized', this.$refs.vuetable)
    },

    methods: {
      onChangeSaleType (value) {
        // Disable filter
        if (this.saleType === value) {
          this.setSaleType(-1)
        } else { // Set filter
          this.setSaleType(value)
        }
      },
      getStatus (status) {
        if (this.saleType === 4 && status === 2) {
          return 'Packed'
        } else if (this.saleType === 4 && status === 6) {
          return 'Packed'
        } else if (this.saleType === 1 && status !== 99) {
          return 'En Route'
        } else if (status === 0) {
          return 'New'
        } else if (status === 1) {
          return 'On shelf'
        } else if (status === 2) {
          return 'In oven'
        } else if (status === 3) {
          return 'Packing'
        } else if (status === 4) {
          return 'Ready for delivery'
        } else if (status === 5) {
          return 'En Route'
        } else if (status === 6) {
          return 'Delivered'
        } else if (status === 7) {
          return 'Customer not home'
        } else if (status === 98) {
          return 'Cancelled by refund'
        } else if (status === 99) {
          return 'Cancelled order'
        } else {
          return 'Unknown'
        }
      },
      onFilterSet (filterText) {
        this.filterText = filterText
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      },
      onItemsPerPage (itemsPerPageValue) {
        this.perPage = itemsPerPageValue
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      refreshData () {
        Vue.nextTick(() => this.$refs.vuetable.reload())
      },
      dataManager (sortOrder, pagination) {
        let data = this.filteredTableData.data
        let sortFunctions = this.sortFunctions

        if (sortOrder.length > 0) {
          data.sort(function (item1, item2) {
            const sortField = sortOrder[0].sortField
            let fn = sortFunctions[sortField]
            if (fn) {
              return fn(item1[sortField], item2[sortField])
            }
          })

          if (sortOrder[0].direction === 'desc') {
            data.reverse()
          }
        }

        pagination = this.$refs.vuetable.makePagination(data.length)
        return {
          pagination: pagination,
          data: data.slice(pagination.from - 1, pagination.to)
        }
      },
      onRowClass (dataItem, index) {
        const classes = ['row-delivery-instore', 'row-en-route', 'row-delivered', 'row-ta-instore', 'row-ta-collected']
        return classes[dataItem.state]
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../sass/variables";

  .vuestic-data-table {
    overflow: visible;
    .form-group {
      margin-bottom: 1rem;
    }

    .sale-btn.btn-group .btn i {
      display: none;
    }

    table {
      th {
        position: sticky;
        top: 0px;
        background-color: white;
        box-sizing: border-box;
      }
    }

    .table-holder {
      @media (max-width: 1140px) {
        overflow-x: auto;
      }
    }

    .td-delivery-instore {
      color: $td-delivery-instore
    }
    .td-en-route {
      color: $td-en-route
    }
    .td-delivered {
      color: $td-delivered
    }
    .td-ta-instore {
      color: $td-ta-instore
    }
    .td-ta-collected {
      color: $td-ta-collected
    }
    tr.row-delivery-instore + tr:not(.row-delivery-instore) {
      border-top: 2px solid;
      border-color: #555555;
    }
    tr.row-delivery-instore + tr:not(.row-delivery-instore) td {
      padding-top: 80px;
    }
    tr.row-en-route + tr:not(.row-en-route) {
      border-top: 2px solid;
      border-color: #555555;
    }
    tr.row-en-route + tr:not(.row-en-route) td {
      padding-top: 80px;
    }
    tr.row-delivered + tr:not(.row-delivered) {
      border-top: 2px solid;
      border-color: #555555;
    }
    tr.row-delivered + tr:not(.row-delivered) td {
      padding-top: 80px;
    }
    tr.row-ta-instore + tr:not(.row-ta-instore) {
      border-top: 2px solid;
      border-color: #555555;
    }
    tr.row-ta-instore + tr:not(.row-ta-instore) td {
      padding-top: 80px;
    }
    tr.row-ta-collected + tr:not(.row-ta-collected) {
      border-top: 2px solid;
      border-color: #555555;
    }
    tr.row-ta-collected + tr:not(.row-ta-collected) td {
      padding-top: 80px;
    }
    @media (max-width: 1258px) {
      .sale-btn.btn-group .btn {
        padding-left: 0.8rem;
        padding-right: 0.8rem;
      }
    }

    @media (max-width: 1258px) {
      .sale-btn.btn-group {
        margin-bottom: 10px;
      }

      .datatable-controls .btn.dropdown-toggle {
        margin-left: 0;
      }

      .sale-btn.btn-group .btn span {
        display: none;
      }

      .sale-btn.btn-group .btn i {
        display: block;
      }

      .pagination-link-btn:first-child .pagination-link-btn:last-child {
        display: none;
      }

      .pagination-link-btn:nth-child(3) {
        border-top-left-radius: $btn-border-radius !important;
        border-bottom-left-radius: $btn-border-radius !important;
      }

      .pagination-link-btn:nth-last-child(3) {
        border-top-right-radius: $btn-border-radius !important;
        border-bottom-right-radius: $btn-border-radius !important;
      }
    }

    @media (max-width: 576px) {
      .hide-not-focused-btn:not(.focus) {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-datatable/VuesticDataTable.vue